export default function fillZero(val) {
    return val < 10 ? '0' + val : val;
}


// WEBPACK FOOTER //
// ./src/filters/fillZero.js